/**
 * views/index.js
 */
export {default as HomeView} from './home/HomeView';
export {default as NewsWrapper} from './news/NewsWrapper';
export {default as ArticleWrapper} from './news/ArticleWrapper';
export {default as Error404} from './error404/Error404';
export {default as Success} from './success/Success';
export {default as MotdView} from './motd/MotdView';
export {default as NewHomeView} from './home/NewHomeView';
